import ForgotPasswordPage from "@/pages/auth/forgot-password"
import LoginPage from "@pages/auth/login"

const blankRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
]

export default blankRoutes
